import { render, staticRenderFns } from "./folders.vue?vue&type=template&id=7ea22a7b&scoped=true"
import script from "./folders.vue?vue&type=script&lang=js"
export * from "./folders.vue?vue&type=script&lang=js"
import style0 from "./folders.vue?vue&type=style&index=0&id=7ea22a7b&prod&lang=css"
import style1 from "./folders.vue?vue&type=style&index=1&id=7ea22a7b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ea22a7b",
  null
  
)

export default component.exports